module.exports = __webpack_public_path__ + "img/card_grid.15815aa0.svg";